var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/home-basic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-basic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59879 1.49687C9.59862 1.49673 9.59897 1.49701 9.59879 1.49687L14.2191 5.1905C14.5616 5.46623 14.8181 5.87003 14.9752 6.28173C15.1323 6.69357 15.21 7.16595 15.139 7.60054L15.1387 7.60237L14.2521 12.909L14.2518 12.9105C14.0511 14.09 12.9302 15.04 11.7322 15.04H4.26556C3.06141 15.04 1.94651 14.097 1.74588 12.9099L0.859588 7.60543C0.859492 7.60488 0.859397 7.60433 0.859301 7.60378C0.784085 7.16786 0.860175 6.69431 1.01758 6.28173C1.17509 5.86889 1.43397 5.46479 1.78032 5.18918C1.78058 5.18897 1.78085 5.18875 1.78112 5.18854L6.39944 1.48984C7.28971 0.776152 8.70356 0.777769 9.59879 1.49687ZM8.97233 2.27632C8.44095 1.84923 7.54794 1.85068 7.02503 2.26999L2.40337 5.97137C2.23011 6.10908 2.0626 6.34801 1.95189 6.63819C1.84116 6.92844 1.80724 7.21755 1.84487 7.43452L1.8454 7.43757L2.7319 12.7433C2.73188 12.7432 2.73192 12.7434 2.7319 12.7433C2.85145 13.4494 3.54984 14.04 4.26556 14.04H11.7322C12.4407 14.04 13.1463 13.4437 13.2659 12.7435C13.2659 12.7432 13.266 12.743 13.266 12.7427L14.1521 7.43941C14.1521 7.43911 14.1522 7.43882 14.1522 7.43852C14.1877 7.21988 14.152 6.92931 14.0409 6.63819C13.9298 6.34687 13.7632 6.10753 13.5925 5.96985C13.5923 5.9697 13.5922 5.96955 13.592 5.9694L8.97335 2.27714L8.97233 2.27632Z",
    fill: "#333853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41934 9.83301C6.93866 9.83301 6.55765 10.2386 6.58763 10.7183L6.83244 14.6352L5.83438 14.6975L5.58958 10.7807C5.52362 9.72526 6.36184 8.83301 7.41934 8.83301H9.15637C10.2591 8.83301 11.1123 9.79951 10.9755 10.8937L10.4962 14.7284L9.50394 14.6043L9.98326 10.7697C10.0454 10.2723 9.65761 9.83301 9.15637 9.83301H7.41934Z",
    fill: "#333853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c7fe17ef903e8b2fbea77a0de20d9a62.svg";
export { ForwardRef as ReactComponent };